import * as React from "react"
import { connect } from "react-redux"

import { Action } from "@tenforce/toolbox-button-push-react"

import { Symbols } from "@tenforce/toolbox-fontmap"
import OldUIContext from "../../../../olduicontext"
import { DispatchProps, mapDispatchToProps } from "../../actions"
import { formatString } from "../../../../util/Strings"
import { GlobalState } from "../../../../store"
import { Labels } from "../../../../util/Translations"
import { WorkspacesInfo } from "../../index"

type StateProps = WorkspacesInfo

type Props = StateProps & DispatchProps

interface State {
    hasHover: boolean
}

export class LoadMore extends React.PureComponent<Props, State> {
    static contextType = OldUIContext
    context: React.ContextType<typeof OldUIContext>

    constructor(props: Props, context?: typeof OldUIContext) {
        super(props, context)
        this.state = {
            hasHover: false,
        }
    }

    render(): JSX.Element {
        const {
            loadMoreWorkspaces,
            pagination: { pageSize, count },
            workspaces,
        } = this.props
        const { hasHover } = this.state
        const { LoadNMore } = Labels

        const workspacesLeft = count - workspaces.length
        const nextPageSize =
            workspacesLeft < pageSize ? workspacesLeft : pageSize
        const loadMoreLabel = formatString(LoadNMore, nextPageSize)

        return (
            <li
                onMouseEnter={(): void => this.setHover(true)}
                onMouseLeave={(): void => this.setHover(false)}
            >
                <Action
                    onClick={(): void => {
                        loadMoreWorkspaces()
                    }}
                    extraClasses={`tw-my-1 tw-py-1 tw-px-3 theme-bubble tw-flex tw-items-center tw-w-full ${
                        hasHover ? "bg-cloud" : ""
                    }`}
                    id="workspaceLoadMore"
                >
                    <h3>{Symbols.ExpandDoubleArrowDown}</h3>
                    <div>
                        <div className="p">{loadMoreLabel}</div>
                    </div>
                </Action>
            </li>
        )
    }

    setHover = (hasHover: boolean): void => {
        this.setState({ hasHover })
    }
}

const mapStateToProps = (state: GlobalState): StateProps => ({
    ...state.conceptsPage.workspacesInfo,
})

export default connect(mapStateToProps, mapDispatchToProps)(LoadMore)
